import { Pipe, PipeTransform } from '@angular/core';
import { EManagementType } from 'src/models/common.model';

@Pipe({
  name: 'mType',
  standalone: false
})
export class ManagementTypePipe implements PipeTransform {
  public transform(portfolioManagementType: EManagementType | null, checking: 'PM' | 'EO'): boolean {
    if (!portfolioManagementType) return false;
    if (checking === 'PM') {
      return portfolioManagementType === EManagementType.PORTFOLIO_MANAGEMENT;
    }
    if (checking === 'EO') {
      return portfolioManagementType === EManagementType.EXECUTION_ONLY;
    }
    throw new Error('Unsupported user management type: ' + checking);
  }
}